import {
    EnvironmentName,
    LocalEnvironmentName,
    OttoEnvironmentHost,
    StargateEnvironmentHost,
} from "waapi/environments-repository/constants/environments.js";
import { SecondaryAccountType } from "waapi/girbal/Store/types.js";
import { UseUserStateState } from "./userState.types.js";

export const getApiUrl = (state: UseUserStateState) => state.environment.apiUrl;
export const getUserId = (state: UseUserStateState) => state.auth?.secondaryAccount?.userId || state.auth?.rootAccount?.userId;
export const getSocketUrl = (state: UseUserStateState) => {
    const res = state.environment?.frontSocketUrl ?? state.environment?.socketUrl;
    if (res === `https://${StargateEnvironmentHost.PROD}/`) return `https://${OttoEnvironmentHost.PROD}`;

    return res;
};
export const getApiToken = (state: UseUserStateState) => state.auth?.secondaryAccount.apiToken || state.auth?.rootAccount.apiToken;
export const isCurrentlyImpersonating = (state: UseUserStateState) =>
    !!(state.auth?.secondaryAccount.apiToken && state.auth?.secondaryAccount.accountType === SecondaryAccountType.IMPERSONATION);
export const getMemberId = (state: UseUserStateState) => state.auth?.linkedinAccount.profile?.memberId;

export const getLinkedinProfile = (state: UseUserStateState) => state.auth?.secondaryAccount?.profile || state.auth?.linkedinAccount.profile;

export const getPermissions = (state: UseUserStateState) => state.permissions || []; // SHALLOW

export const getLinkedinId = (state: UseUserStateState) =>
    state.auth?.secondaryAccount?.profile?.linkedinId || state.auth?.linkedinAccount.profile?.linkedinId?.toString();

export const isPremiumSubscriber = (state: UseUserStateState) => !!state.auth.linkedinAccount.profile?.isPremiumSubscriber;

export const isRecruiter = (state: UseUserStateState) => !!state.auth.linkedinAccount.profile?.isRecruiter;

export const getRootUserId = (state: UseUserStateState) => state.auth?.rootAccount?.userId;

export const isLoggedInAnOtherAccountSelector = (state: UseUserStateState) =>
    !!(state.auth?.secondaryAccount?.userId && state.auth?.secondaryAccount?.accountType === SecondaryAccountType.STAFF_CRM_ACCESS);

export const selectUserPlan = (state: UseUserStateState) =>
    state.company?.plan
        ? {
              trial: null,
              ...state.currentPlan,
              ...state.company.plan,
          }
        : state.currentPlan;

export const selectUserCompany = (state: UseUserStateState) => state.company;

export const getIntercomIdentifiers = (state: UseUserStateState) => state.intercomIdentifiers;

export const getSelectedEnvironment = (state: UseUserStateState) => state.environment.selectedEnvironment;

export const getEnvironment = (state: UseUserStateState) => {
    if (!state.environment.selectedEnvironment) return "production";
    if (state.environment.selectedEnvironment === LocalEnvironmentName.LOCAL) return "development";
    if (state.environment.selectedEnvironment === EnvironmentName.PROD || (state.environment.selectedEnvironment as unknown) === "production")
        return "production";
    return "staging";
};

export const getIsStaff = (state: UseUserStateState) => state.isStaff;
